const localeKo = {}

export default localeKo
